// Embed instructions:
// To populate the modified embed field change the height from 482 to 100%.
// The hardcoded styling needs to be changed in order to display properly.
const podcasts = [
  {
    title: 'The New Way We Work',
    slug: 'new-way-we-work', // User facing slug
    wp_slug: 'the-new-way-we-work-podcast',
    tag: 'The New Way We Work podcast',
    blurb: `Fast Company deputy editor Kate Davis takes listeners on a journey though the changing landscape of our work lives and explains what we need to build the future we want. Available wherever you listen to podcasts. Subscribe now.`,
    links: [
      {
        platform: 'Apple Podcasts',
        link: 'https://podcasts.apple.com/podcast/id1393035987'
      },
      {
        platform: 'Spotify',
        link: 'https://open.spotify.com/show/2POyz4d2ymhs8NqSBY7gfW'
      },
      {
        platform: 'Google Podcasts',
        link:
          'https://podcasts.google.com/?feed=aHR0cHM6Ly9yc3Muc2ltcGxlY2FzdC5jb20vcG9kY2FzdHMvNTg3Mi9yc3M%3D'
      },
      {
        platform: 'Stitcher',
        link:
          'https://www.stitcher.com/podcast/fast-company/secrets-of-the-most-productive-people'
      }
    ],
    embed: `<iframe frameborder="0" src="https://playlist.megaphone.fm?p=MANV3867221972&light=true" width="100%" height="482"></iframe>`,
    modifiedEmbed: `<iframe frameborder="0" src="https://playlist.megaphone.fm?p=MANV3867221972&light=true" width="100%" height="100%"></iframe>`,
    image:
      'https://assets.fastcompany.com/image/upload/w_1153,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy/v1610657570/NewWay.jpg'
  },
  {
    title: 'Creative Conversation',
    slug: 'creative-conversation',
    wp_slug: 'creative-conversation-podcast',
    tag: 'creative conversation podcast',
    blurb: `Fast Company's KC Ifeanyi dives into the most creative minds in film, TV, music, and beyond to unlock their creative processes. Available wherever you listen to podcasts. Subscribe now.`,
    links: [
      {
        platform: 'Apple Podcasts',
        link:
          'https://podcasts.apple.com/podcast/idhttps-podcasts-apple-com-us-podcast-creative-conversation/id1393035409'
      },
      {
        platform: 'Spotify',
        link: 'https://open.spotify.com/show/0YDfXMXCT4yamNLdWBULgm'
      },
      {
        platform: 'Google Podcasts',
        link:
          'https://podcasts.google.com/?feed=aHR0cHM6Ly9mZWVkcy5tZWdhcGhvbmUuZm0vTUFOVjgxMDYyODkwMzM%3D'
      },
      {
        platform: 'Stitcher',
        link:
          'https://www.stitcher.com/podcast/fast-company/creative-conversation'
      }
    ],
    embed: `<iframe frameborder="0" src="https://playlist.megaphone.fm?p=MANV8106289033&light=true" width="100%" height="482"></iframe>`,
    modifiedEmbed: `<iframe frameborder="0" src="https://playlist.megaphone.fm?p=MANV8106289033&light=true" width="100%" height="100%"></iframe>`,
    image:
      'https://images.fastcompany.net/image/upload/w_1153,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy/v1585939566/fcweb/CreativeConversation_WebsiteTopArt_rl1shq.jpg'
  },
  {
    title: 'World Changing Ideas',
    slug: 'world-changing-ideas',
    wp_slug: 'world-changing-ideas-podcast',
    tag: 'world changing ideas podcast',
    blurb: `Join Fast Company’s Talib Visram as he investigates the innovations that are solving our biggest problems, from rethinking food production to developing a circular economy to taking on climate change. Available wherever you listen to podcasts. Subscribe now.`,
    links: [
      {
        platform: 'Apple Podcasts',
        link: 'https://podcasts.apple.com/us/podcast/fast-break/id1504787159'
      },
      {
        platform: 'Spotify',
        link: 'https://open.spotify.com/show/6qhfc6mZXbHFQK0hGOUjJ4'
      },
      {
        platform: 'Google Podcasts',
        link:
          'https://podcasts.google.com/?feed=aHR0cHM6Ly9mZWVkcy5tZWdhcGhvbmUuZm0vZmFzdGJyZWFr&ved=0CBgQ27cFahcKEwjY8YCW2-XoAhUAAAAAHQAAAAAQBQ'
      },
      {
        platform: 'Stitcher',
        link: 'https://www.stitcher.com/podcast/fast-company/fast-break-2'
      }
    ],
    embed: `<iframe frameborder="0" src="https://playlist.megaphone.fm?p=MANV5546106257&light=true" width="100%" height="482"></iframe>`,
    modifiedEmbed: `<iframe frameborder="0" src="https://playlist.megaphone.fm?p=MANV5546106257&light=true" width="100%" height="100%"></iframe>`,
    image:
      'https://images.fastcompany.net/image/upload/w_1153,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy/v1614101062/fcweb/WCI_Podcast_Cover_Web_ygotsq.jpg'
  },
  {
    title: 'Hit the Ground Running',
    slug: 'hit-the-ground-running',
    wp_slug: 'hit-the-ground-running-podcast',
    tag: 'Hit the Ground Running Podcast',
    blurb: `Join hosts Christina Royster and Yasmin Gagne as they figure out how to navigate the unwritten rules of work and life, exploring everything from what to wear on a zoom call to how to manage a side hustle. Available wherever you listen to podcasts. Subscribe now.`,
    links: [
      {
        platform: 'Apple Podcasts',
        link:
          'https://podcasts.apple.com/us/podcast/hit-the-ground-running/id1558760059'
      },
      {
        platform: 'Spotify',
        link:
          'https://open.spotify.com/show/3hZ9uFtZ2ZIlaHfEjS2Vs4?si=lk5l3FY7SlWi--yk2ITlfw'
      }
      // {
      //   platform: 'Google Podcasts',
      //   link:
      //     'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5tZWdhcGhvbmUuZm0vaHRncg'
      // }
      // {
      //   platform: 'Stitcher',
      //   link:
      //     'https://www.stitcher.com/podcast/fast-company/hit-the-ground-running'
      // }
    ],
    embed: `<iframe frameborder="0" src="https://playlist.megaphone.fm/?p=MANV9899270960&light=true" width="100%" height="482"></iframe>`,
    modifiedEmbed: `<iframe frameborder="0" src="https://playlist.megaphone.fm/?p=MANV9899270960&light=true" width="100%" height="100%"></iframe>`,
    image:
      'https://assets.fastcompany.com/image/upload/v1617050229/HTGR_Podcast_WebsiteTopArt_new.jpg'
  }
];

export default podcasts;
